import { NEW_PRODUCT_MAX_AGE_DAYS } from "@/utils/isNewProduct";

/** Windows above a year are treated as unset and fall back to 90. */
const MAX_NEW_WINDOW_DAYS = 365;

export const parseNewWindowDays = (
  value: string | number | null | undefined,
): number => {
  if (value === undefined || value === null || value === "") {
    return NEW_PRODUCT_MAX_AGE_DAYS;
  }
  const parsed = typeof value === "number" ? value : Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0 || parsed > MAX_NEW_WINDOW_DAYS) {
    return NEW_PRODUCT_MAX_AGE_DAYS;
  }
  return Math.floor(parsed);
};
